import axios from '@/axios-api';
import Pathes from '@/helpers/pathes';

export const dashboardService = {
  partnersCount: () => axios.get(Pathes.Fundraising.partnerCounts),
  lenderStats: () => axios.get(Pathes.Dashboard.lenderStats),
};
